export default {
  label: {
    en: 'New at Scentbird',
  },
  supTitle: {
    en: 'Buy any 4 travel-size fragrances',
  },
  title: {
    en: 'Get the 5th free',
  },
  addMore: {
    en: 'Add {count, select, 1 {one} 2 {two} 3 {three} 4 {four}} more travel-size {count, plural, one {fragrance} other {fragrances}} to your cart.',
  },
  qualify: {
    en: 'You qualify for a free fragrance!',
  },
  congrats: {
    en: 'Congrats, your reward has been applied to your cart!',
  },
}
